module.exports = __webpack_public_path__ + "static/media/Worlds - Hexagon 1.51810aa8.png";